import { Components, Theme } from '@mui/material'

export const MuiListItem: Components<Omit<Theme, 'components'>>['MuiListItem'] = {
  styleOverrides: {
    divider: ({ theme }) => ({
      borderBottomWidth: theme.strokeWidth.default,
      borderBottomColor: theme.palette.border.strong,
    }),
  },
}
